import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { OrgDropdown } from "./OrgDropdown";
import { DEBUG_STATE } from "../../constants/constants.js"

function OrgCreate(props) {
  const { authentication, org, createOrg, getOrgTypes, getOrgDetail, setCurrentOrgId } = props;
  const org_id = props.match.params.id;
  const orgTypes = org?.org_types ? org.org_types : [];

  const cancelicon = require("../../images/status-red.png").default;
  const saveicon = require("../../images/status-green.png").default;

  const debug = DEBUG_STATE;


  const [orgRequest, setOrgRequest] = useState({});
  const [orgType, setOrgType] = useState("");
  const [allowManifest, setAllowManifest] = useState(false);
  const [allowShipping, setAllowShipping] = useState(false);
  const [shippingProvider, setShippingProvider] = useState('');
  const [allowUpload, setAllowUpload] = useState(false);
  const [allowDocTypes, setAllowDocTypes] = useState(false);
  const [allowAddons, setAllowAddons] = useState(false);
  const [allowClassification, setAllowClassification] = useState(false);
  const [allowFileSplitting, setAllowFileSplitting] = useState(false);
  const [parentOrgId, setParentOrgId] = useState(org.current_org_id);


  useEffect(() => {
    setCurrentOrgId(org_id);
  }, [org_id])


  useEffect(() => {
    if (orgTypes.length === 0) getOrgTypes();
  }, [orgTypes]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!allowManifest) {
      orgRequest["jotform_code"] = "";
    }
    if (!allowShipping) {
      orgRequest["street_1"] = "";
      orgRequest["street_2"] = "";
      orgRequest["city"] = "";
      orgRequest["state"] = "";
      orgRequest["zip"] = "";
      orgRequest["allow_shipping_label"] = false;
    } else {
      orgRequest["allow_shipping_label"] = true;
      orgRequest["shipping_provider"] = shippingProvider;
    }
    orgRequest["parent_org_id"] = Number(parentOrgId);
    orgRequest["allow_doc_types"] = allowDocTypes;
    orgRequest["allow_upload"] = allowUpload;
    orgRequest["allow_addons"] = allowAddons;
    orgRequest["allow_classification"] = allowClassification;
    orgRequest["allow_file_splitting"] = allowFileSplitting
    orgRequest["org_type"] = orgType;
    if (debug) {
      console.log(orgRequest);
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    createOrg(orgRequest);
  };

  const parentOrgIdChange = (event) => {
    setParentOrgId(event.target.value);
  };

  const setDisplayName = (e) => {
    const { value } = e.target;
    orgRequest["display_name"] = value;
  };

  const setLegalName = (e) => {
    const { value } = e.target;
    orgRequest["legal_name"] = value;
  };

  const orgTypeChange = (event) => {
    setOrgType(event.target.value);
  };

  const setOrgEmail = (e) => {
    const { value } = e.target;
    orgRequest["org_email"] = value;
  };

  const setOrgPhone = (e) => {
    const { value } = e.target;
    orgRequest["org_phone"] = value;
  };

  const handleChangeAllowManifest = () => {
    setAllowManifest(!allowManifest);
  };

  const setJotformCode = (e) => {
    const { value } = e.target;
    orgRequest["jotform_code"] = value;
  };

  const handleChangeAllowShipping = () => {
    setAllowShipping(!allowShipping);
  };

  const setStreet1 = (e) => {
    const { value } = e.target;
    orgRequest["street_1"] = value;
  };

  const setStreet2 = (e) => {
    const { value } = e.target;
    orgRequest["street_2"] = value;
  };

  const setCity = (e) => {
    const { value } = e.target;
    orgRequest["city"] = value;
  };

  const setState = (e) => {
    const { value } = e.target;
    orgRequest["state"] = value;
  };

  const setZip = (e) => {
    const { name, value } = e.target;
    orgRequest["zip"] = value;
  };

  const shippingProviderChange = (e) => {
    setShippingProvider(e.target.value);
  }

  const setShippingContactEmail = (e) => {
    const { value } = e.target;
    orgRequest["contact_email"] = value;
  };

  const setShippingContactPhone = (e) => {
    const { value } = e.target;
    orgRequest["contact_phone"] = value;
  };

  const handleChangeAllowUpload = () => {
    setAllowUpload(!allowUpload);
  };

  const handleChangeAllowDocTypes = () => {
    setAllowDocTypes(!allowDocTypes);
  };

  const handleChangeAllowAddons = () => {
    setAllowAddons(!allowAddons);
  };

  const handleChangeAllowClassification = () => {
    setAllowClassification(!allowClassification);
  };

  const setModelName = (e) => {
    const { name, value } = e.target;
    orgRequest["model_name"] = value;
  };

  const handleChangeAllowFileSplitting = () => {
    setAllowFileSplitting(!allowFileSplitting);
  };

  return (
    <div className="searchMain">
      <div className="contentContainerLeftNav">
        <div className="rightContent">
          <h3>
            create new org
            &nbsp;&nbsp;&nbsp;
            <span className="h3SubSpan">(creating)</span>
            &nbsp;&nbsp;&nbsp;
            <div className="editJacketNameIcon" onClick="" data-tip data-for="cancel">
              <Link
                to={{
                  pathname: "/orgs/"

                }}
              >
                <img src={cancelicon} className="cancelImage" width="20px" alt="cancel" />
              </Link>
            </div>
            &nbsp;&nbsp;&nbsp;
            <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
              cancel
            </ReactTooltip>
            <div className="editJacketNameIcon" onClick="" data-tip data-for="save" >
              <img src={saveicon} className="saveImage" width="20px" alt="save" onClick={handleSubmit} />
            </div>
            <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
              save
            </ReactTooltip>
          </h3>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Contact
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel"><span className="requiredAsterisk">*</span>Display Name</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="display_name"
                      name="display_name"
                      type="text"
                      onChange={setDisplayName}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="formLabel"><span className="requiredAsterisk">*</span>Legal Name</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="legal_name"
                      name="legal_name"
                      type="text"
                      onChange={setLegalName}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="formLabel"><span className="requiredAsterisk">*</span>Type</td>
                  <td className="formInfo">
                    <select className="orgTypeDropdown"
                      id="org_type"
                      value={orgType === null ? orgTypes[0] : orgType}
                      onChange={orgTypeChange}
                    >
                      {orgTypes?.map((type, i) => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td className="formLabel"><span className="requiredAsterisk">*</span>Parent Org</td>
                  <td className="formInfo">
                    <OrgDropdown handler={parentOrgIdChange} />
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Contact Email</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="org_email"
                      name="org_email"
                      type="text"
                      onChange={setOrgEmail}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Contact Phone</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="org_phone"
                      name="org_phone"
                      type="text"
                      onChange={setOrgPhone}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Manifest
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Manifest?</td>
                  <td className="formInfo">
                    {
                      allowManifest && (<input type="checkbox" checked onChange={handleChangeAllowManifest} />)
                    }
                    {
                      !(allowManifest) && (<input type="checkbox" onChange={handleChangeAllowManifest} />)
                    }
                  </td>
                </tr>

                {allowManifest && (
                  <>
                    <tr>
                      <td className="formLabel"><span className="requiredAsterisk">*</span>Jotform URL</td>
                      <td className="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="joform_code"
                          name="jotform_code"
                          autoComplete="off"
                          onChange={setJotformCode}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="formLabel"></td>
                      {orgRequest?.jotform_code && (
                        <td className="formInfo">
                          <a href={orgRequest.jotform_code} target="_blank">view manifest</a>
                        </td>
                      )}
                    </tr>
                  </>
                )}

              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Shipping
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Shipping Label?</td>
                  <td className="formInfo">
                    {
                      allowShipping && (<input type="checkbox" checked onChange={handleChangeAllowShipping} />)
                    }
                    {
                      !(allowShipping) && (<input type="checkbox" onChange={handleChangeAllowShipping} />)
                    }
                  </td>
                </tr>
                {
                  (allowShipping) && (
                    <>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Shipping Provider</td>
                        <td className="formInfo">
                          <select className="orgTypeDropdown"
                            id="shipping_provider"
                            value={shippingProvider === null ? "fedex_2_day" : shippingProvider}
                            onChange={shippingProviderChange}
                          >
                            <option key={'fedex_2_day'} value={'fedex_2_day'}>fedex_2_day</option>
                            <option key={'ups_second_day_air'} value={'ups_second_day_air'}>ups_second_day_air</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2" className="formLabelCentered">
                          <b>Shipping Address</b>
                        </td>
                      </tr>

                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Street address (line 1)</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="street_1"
                            name="street_1"
                            autoComplete="off"
                            onChange={setStreet1}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel">Street address (line 2)</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="street_2"
                            name="street_2"
                            autoComplete="off"
                            onChange={setStreet2}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>City</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="city"
                            name="city"
                            autoComplete="off"
                            onChange={setCity}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>State</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="state"
                            name="state"
                            autoComplete="off"
                            onChange={setState}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Zip</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="zip"
                            name="zip"
                            autoComplete="off"
                            onChange={setZip}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Shipping Contact Email</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="zip"
                            name="zip"
                            autoComplete="off"
                            onChange={setShippingContactEmail}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Shipping Contact Phone</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="zip"
                            name="zip"
                            autoComplete="off"
                            onChange={setShippingContactPhone}
                          />
                        </td>
                      </tr>
                    </>
                  )}
              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Upload
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Self-Serve Upload?</td>
                  <td className="formInfo">
                    {
                      (allowUpload) && (<input type="checkbox" checked onChange={handleChangeAllowUpload} />)
                    }
                    {
                      !(allowUpload) && (<input type="checkbox" onChange={handleChangeAllowUpload} />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Doc Type Permissioning?</td>
                  <td className="formInfo">
                    {
                      allowDocTypes && (<input type="checkbox" checked onChange={handleChangeAllowDocTypes} />)
                    }
                    {
                      !(allowDocTypes) && (<input type="checkbox" onChange={handleChangeAllowDocTypes} />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Self-Serve Addons?</td>
                  <td className="formInfo">
                    {
                      allowAddons && (<input type="checkbox" checked onChange={handleChangeAllowAddons} />)
                    }
                    {
                      !(allowAddons) && (<input type="checkbox" onChange={handleChangeAllowAddons} />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Classification Pipeline?</td>
                  <td className="formInfo">
                    {
                      allowClassification && (<input type="checkbox" checked onChange={handleChangeAllowClassification} />)
                    }
                    {
                      !(allowClassification) && (<input type="checkbox" onChange={handleChangeAllowClassification} />)
                    }
                  </td>
                </tr>
                {
                  allowClassification && (
                    <tr>
                      <td className="formLabel">Classification Model</td>
                      <td className="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="model_name"
                          name="model_name"
                          autoComplete="off"
                          onChange={setModelName}
                        />
                      </td>
                    </tr>
                  )}
                <tr>
                  <td className="formLabel">Allow File Splitting?</td>
                  <td className="formInfo">
                    {
                      allowFileSplitting && (<input type="checkbox" checked onChange={handleChangeAllowFileSplitting} />)
                    }
                    {
                      !(allowFileSplitting) && (<input type="checkbox" onChange={handleChangeAllowFileSplitting} />)
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />
          <div className="cancelSaveFooter">
            <div className="editJacketNameIcon" data-tip data-for="cancel">
              <Link
                to={{
                  pathname: "/org/list",
                }}
              >
                <img src={cancelicon} className="cancelImage" width="20px" alt="cancel" />
              </Link>
            </div>
            &nbsp;&nbsp;&nbsp;
            <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
              cancel
            </ReactTooltip>
            <div className="editJacketNameIcon" data-tip data-for="save" >
              <img src={saveicon} className="saveImage" width="20px" alt="save" onClick={handleSubmit} />
            </div>
            <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
              save
            </ReactTooltip>
          </div>
        </div>
      </div>
    </div>

  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  createOrg: orgActions.createOrg,
  getOrgTypes: orgActions.getOrgTypes,
  getOrgDetail: orgActions.getOrgDetail,
  setCurrentOrgId: orgActions.setCurrentOrgId
};

const connectedOrgCreate = connect(mapStateToProps, actionCreators)(OrgCreate);
export { connectedOrgCreate as OrgCreate };
